/* SEO Text - Toggle Functionality */
(function() {
  // Almacenar handlers para poder removerlos después
  const sectionHandlers = new WeakMap();

  function init(section) {
    if (!section) return;
    
    // Si ya se inicializó, no hacer nada
    if (section.dataset.seoInitialized === 'true') return;

    const wrapper = section.querySelector('.seo-text__wrapper');
    const toggle = section.querySelector('[data-seo-toggle]');
    const toggleText = section.querySelector('.seo-text__toggle-text');

    if (!wrapper || !toggle || !toggleText) return;

    const textMore = toggleText.dataset.textMore || 'Leer más';
    const textLess = toggleText.dataset.textLess || 'Leer menos';

    function toggleContent(e) {
      // Si se hizo click en el enlace, prevenir que se propague
      if (e && e.target.closest('[data-seo-toggle]')) {
        e.stopPropagation();
      }

      const isExpanded = wrapper.classList.contains('seo-text__wrapper--expanded');

      if (isExpanded) {
        // Colapsar
        wrapper.classList.remove('seo-text__wrapper--expanded');
        wrapper.classList.add('seo-text__wrapper--collapsed');
        toggleText.textContent = textMore;
      } else {
        // Expandir
        wrapper.classList.remove('seo-text__wrapper--collapsed');
        wrapper.classList.add('seo-text__wrapper--expanded');
        toggleText.textContent = textLess;
      }
    }

    // Handlers
    const wrapperHandler = function(e) {
      // Solo expandir si está colapsado
      if (wrapper.classList.contains('seo-text__wrapper--collapsed')) {
        toggleContent(e);
      }
    };

    const toggleHandler = function(e) {
      e.stopPropagation();
      toggleContent(e);
    };

    // Guardar handlers
    sectionHandlers.set(section, { wrapperHandler, toggleHandler, wrapper, toggle });

    // Click en el wrapper completo (solo cuando está colapsado)
    wrapper.addEventListener('click', wrapperHandler);

    // Click en el botón/enlace (funciona siempre)
    toggle.addEventListener('click', toggleHandler);

    // Marcar como inicializado
    section.dataset.seoInitialized = 'true';
  }

  function cleanup(section) {
    if (!section) return;
    
    const handlers = sectionHandlers.get(section);
    if (handlers) {
      handlers.wrapper.removeEventListener('click', handlers.wrapperHandler);
      handlers.toggle.removeEventListener('click', handlers.toggleHandler);
      sectionHandlers.delete(section);
    }
    
    delete section.dataset.seoInitialized;
  }

  function run() {
    document.querySelectorAll('.seo-text').forEach(function(section) {
      init(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function(e) {
    try {
      const section = e.target.querySelector('.seo-text');
      if (section) {
        cleanup(section);
        setTimeout(function() {
          init(section);
        }, 50);
      }
    } catch (err) {
      console.error('Error in seo-text section:load', err);
    }
  });

  document.addEventListener('shopify:section:unload', function(e) {
    try {
      const section = e.target.querySelector('.seo-text');
      if (section) {
        cleanup(section);
      }
    } catch (err) {
      console.error('Error in seo-text section:unload', err);
    }
  });
})();

